<div style="position: relative; /* or absolute */
top: 0%;
left: 1%;
width: 97%;">
  <div class="d-flex align-items-center justify-content-between">
    <span class="d-inline-block"><h2>{{'COMPANY.TITLE' | translate}}</h2></span>
    @if (user?.roles.includes('ADMIN')) {
      <span class="btn-group-sm p-1">
        <button class="btn btn-outline-primary" (click)="addForm.show()"
          title="{{'COMPANY.ADD_TITLE' | translate}}" aria-label="{{'COMPANY.ADD_TITLE' | translate}}">
          <lucide-icon name="plus" size="16"></lucide-icon> {{'COMPANY.ADD_TITLE' | translate}}
        </button>
      </span>
    }
  </div>


  <!-- <ntr-add-button [openView]="'company-add-edit'"></ntr-add-button> -->

  <ntr-datatable [data]="data" [metaInfo]="metaInfo" [entityTitle]="'company'" [canDelete]="false" [modelView]="'company/add-edit'"
    [disableHeader]="false" (onQuery)="onGridQuery($event)" [columns]="columns"
  [headers]="['','username','name','surname']" (onDeleteQuery)="deleteCompany($event)"></ntr-datatable>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="var(--fg-on-navy)" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white; text-align: center;">{{'UTIL.LOADING' | translate}}...</p>
</ngx-spinner>
<app-company-form #addForm [company]="company"></app-company-form>
